module.exports = __webpack_public_path__ + "static/media/pmp-logo-2025.531034a0.png";